import { render, staticRenderFns } from "./CollectionInputContainer.vue?vue&type=template&id=0ee7558c&scoped=true"
import script from "./CollectionInputContainer.vue?vue&type=script&lang=js"
export * from "./CollectionInputContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7558c",
  null
  
)

export default component.exports